import "./qr_list.page.style.scss";
import { FC } from "react";
import KeyWordLocalization from "../../../utils/KeyWordLocalization";
import PaginatorComponent from "../../../components/paginator/PaginatorComponent";
import useQrListViewModel from "./qr_list.page.view_model";
import LayoutComponent from "../../../layouts/layoutComponent/LayoutComponent";
import ButtonComponent from "../../../components/button/ButtonComponent";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent";
import NotResultsComponent from "../../../components/noResults/NoResultsComponent";
import EntitiesConstants from "../../../utils/EntitiesConstants";
import AutoCompleteWithCheckComponent from "../../../components/autocompleteWithCheck/AutoCompleteWithCheckComponent";

const QrListPage: FC<{}> = () => {
    const {
        formInfo,
        result,
        i18n,
        _handleSearch,
        _handleOnChangePage,
        _handleOnClickDisableQr,
        _handleOnCreateQrs,
        _handleDownloadQrBatch,
        _onSearchStablishments,
        _handleChange,
        loading,
    } = useQrListViewModel();

    const { register, handleSubmit } = formInfo;

    return <div className="qr_list_page">
        <LayoutComponent title={i18n("QRs")}>
            <div className="container py-5">
                <form onSubmit={handleSubmit(_handleSearch)}>
                    <div className="row">
                        {/* <div className="col-md-8">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder={i18n("Buscar QRs...")} 
                                {...register(KeyWordLocalization.QrListPageQuery)} 
                                onKeyUp={_handleChangeTextSearch} 
                            />
                        </div> */}
                        <div className="col-md-10">
                            <AutoCompleteWithCheckComponent
                                keyName={KeyWordLocalization.QrListPageStablishment}
                                label="Establecimiento"
                                formInfo={formInfo}
                                multiple={false}
                                onSearch={_onSearchStablishments}
                                onChange={_handleChange}
                            />
                        </div>

                        <div className="col-md-2 d-flex align-items-end">
                            <ButtonComponent
                                className="w-100 d-flex justify-content-center"
                                icon={<span className="material-symbols-outlined">search</span>}
                                text={i18n(KeyWordLocalization.QrListPageSearch)}
                                design="primaryOutline"
                                type="submit"
                            />
                        </div>
                    </div>
                    <div className="w-100 d-flex justify-content-end mt-3">
                        <ButtonComponent
                            design="primaryOutline"
                            onClick={_handleOnCreateQrs}
                            icon={<span className="material-symbols-outlined">add</span>}
                            className="btn_bulk_import"
                            text={i18n("Crear QRs")}
                        />
                    </div>

                    <div className="list">
                        {loading && <div className="mt-5">
                            <LoadingComponent />
                        </div>}
                        {result && result.data.length == 0 && <NotResultsComponent message="Sin resultados, recuerda primero seleccionar un establecimiento para obtener los resultados de este establecimiento" />}
                        {result && result.data.length > 0 && <table className="table my-3" style={{ tableLayout: "auto" }}>
                            <thead>
                                <tr>
                                    <th>{i18n(EntitiesConstants.QrBatchEntityId)}</th>
                                    {/* <th>{i18n(EntitiesConstants.QrBatchEntityStablishment)}</th> */}
                                    <th>{i18n("Disponibles")}</th>
                                    <th>{i18n("Ocupados")}</th>
                                    <th>{i18n(EntitiesConstants.QrBatchEntityCreatedAt)}</th>
                                    <th>{i18n(KeyWordLocalization.QrListPageActions)}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {result.data.map((qr, index) => <tr key={index}>
                                    <td className="hover" style={{ width: 10 }}>
                                        {qr.id}
                                    </td>
                                    {/* <td className="hover">
                                        {qr.stablishment.name}
                                    </td> */}
                                    <td className="hover">
                                        <span className="badge bg-success">
                                            {qr.availables || 0}
                                        </span>
                                    </td>
                                    <td className="hover">
                                        <span className="badge bg-warning">
                                            {qr.used || 0}
                                        </span>
                                    </td>
                                    <td className="hover">
                                        {qr.createdAt.toLocaleDateString()}
                                    </td>
                                    <td style={{ width: '15em' }}>
                                        {
                                            qr.disabled != true && <>
                                            <div className="d-flex gap-2">
                                            <ButtonComponent
                                                icon={<span className="material-symbols-outlined">download</span>}
                                                className="btn-sm"
                                                type="button"
                                                text={i18n("Descargar")}
                                                onClick={async () => await _handleDownloadQrBatch?.(qr)}
                                            />
                                            <ButtonComponent
                                                icon={<span className="material-symbols-outlined">delete</span>}
                                                design="dangerOutline"
                                                className="btn-sm"
                                                text={i18n("Deshabilitar")}
                                                onClick={async () => await _handleOnClickDisableQr?.(qr)}
                                                type="button"
                                            />
                                        </div></>
                                        }
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>}
                    </div>
                    <div className="paginator">
                        {result && result.pages > 1 &&
                            <PaginatorComponent resultData={result} onChangePage={_handleOnChangePage} />
                        }
                    </div>
                </form>
            </div>
        </LayoutComponent>
    </div>
}

export default QrListPage;